import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ApplicationsList from "../../ui/modules/notifications/components/applicationsList/ApplicationsList";
import ApplicationInfo from "../../ui/modules/notifications/components/applicationInfo/ApplicationInfo";
import EntranceExamsList from "../../ui/modules/notifications/components/entranceExamsList/EntranceExamsList";
import { useAppSelector } from "../hooks/redux";
import {
  ENTRANCE_EXAMS_ROUTE_PATH,
  getDefaultNotificationPath,
  isNotificationEducationTypeVisible,
  NOTIFICATION_ROUTE_PATHS,
} from "../constants/admissionDomainConfig";
import BlockedRouteRedirect from "./BlockedRouteRedirect";
import degreeType from "../types/degreeType";

const NotificationsRoutes: React.FC = () => {
  const { accountState } = useAppSelector((state) => state.coreState);

  const defaultNotificationPath = getDefaultNotificationPath(
    accountState.hasCompletedHighEducationApplications,
    accountState.hasCompletedAdditionalEducationApplications,
    accountState.ss
  );

  const autoRedirectFromRoot = (): React.ReactNode => <Navigate to={defaultNotificationPath} />;

  const renderBlockedNotificationRoute = (type: degreeType): React.ReactNode => (
    <Route
      key={type}
      path={`${NOTIFICATION_ROUTE_PATHS[type]}/*`}
      element={<BlockedRouteRedirect />}
    />
  );

  return (
    <Routes>
      <Route path="" element={autoRedirectFromRoot()} />

      {isNotificationEducationTypeVisible("high") ? (
        <Route path={NOTIFICATION_ROUTE_PATHS.high}>
          <Route path="" element={<ApplicationsList degree="high" />} />
          <Route path="general" element={<ApplicationInfo degree="high" isGeneral />} />
          <Route path=":id" element={<ApplicationInfo degree="high" />} />
        </Route>
      ) : (
        renderBlockedNotificationRoute("high")
      )}

      <Route path={ENTRANCE_EXAMS_ROUTE_PATH} element={<EntranceExamsList />} />

      {isNotificationEducationTypeVisible("additional") ? (
        <Route path={NOTIFICATION_ROUTE_PATHS.additional}>
          <Route path="" element={<ApplicationsList degree="additional" />} />
          <Route path="general" element={<ApplicationInfo degree="additional" isGeneral />} />
          <Route path=":id" element={<ApplicationInfo degree="additional" />} />
        </Route>
      ) : (
        renderBlockedNotificationRoute("additional")
      )}

      {!isNotificationEducationTypeVisible("postgraduate") &&
        renderBlockedNotificationRoute("postgraduate")}
    </Routes>
  );
};

export default NotificationsRoutes;
